import { apiRequestActions } from '@ackee/redux-utils';
import { fetchIncidentsTypes } from './types';

export default apiRequestActions(fetchIncidentsTypes);
